import Image from "@components/Image";
import ImageGalleryNavOutside from "@components/ImagesGallery/ImageGalleryNavOutside";
import cx from "classnames";
import styles from "./Banner.module.scss";
import { usePageContext } from "@providers/PageProvider";
import { aboutUsPage } from "@utils/helper";
import _ from "lodash";

export default function FeaturedBanner() {
  const { pageData } = usePageContext();
  const featuredBanner = aboutUsPage.formatFeaturedBanner(pageData);
  return (
    <div
      data-scroll-section
      className={cx("relative", styles.featuredBannerSection)}
    >
      <ImageGalleryNavOutside
        className={cx(styles.featuredBanner)}
        galleryName={"aboutUsGallery"}
        images={_.get(featuredBanner, "aboveImages", [])}
      />

      <div
        className="absolute"
        style={{ top: "50%", transform: "translateY(-50%)" }}
      >
        <Image
          speed={0}
          wrapperProps={{ className: cx(styles.bgFeaturedBanner) }}
          src={_.get(featuredBanner, "belowImage.src", {}) ?? '/about/us/banner/bg.svg'}
          alt={_.get(featuredBanner, "belowImage.alt", "") ?? "background-featured-banner"}
          layout="fill"
        />
      </div>
    </div>
  );
}
